
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns806aef456ead183ded74eea0281b2a21en from './en.yaml'
            i18n.addResourceBundle('en', '806aef456ead183ded74eea0281b2a21', flattenObject(ns806aef456ead183ded74eea0281b2a21en), true, true);
        
        export default '806aef456ead183ded74eea0281b2a21';
    